import React from 'react';
import { connect } from 'react-redux';

import EmissionsDisaggregatedByCustomCategoryRow from './EmissionsDisaggregatedByCustomCategoryRow';

const EmissionsDisaggregatedByCustomCategory = ({ customLabels, emissionsByCustomCategory, orgs }) => {
  if (!(customLabels && customLabels.length > 0)) {
    return null;
  }
  return (
    <div className='my-8'>
      <h3 className='text-lg font-semibold mb-4 text-foreground'>Emissions disaggregated by custom category</h3>
      <div className='overflow-x-auto rounded shadow'>
        <table className='min-w-full bg-card text-card-foreground border border-border'>
          <thead className='bg-muted'>
            <tr>
              <th className='w-1/5 px-4 py-2 text-left font-semibold text-muted-foreground'>Custom Category</th>
              <th className='w-1/5 px-4 py-2 text-center font-semibold text-muted-foreground'>Organisation</th>
              <th className='w-1/5 px-4 py-2 text-right font-semibold text-muted-foreground'>Total (tCO2e)</th>
              <th className='w-1/5 px-4 py-2 text-right font-semibold text-muted-foreground hidden sm:table-cell'>
                Scope 1 (tCO2e)
              </th>
              <th className='w-1/5 px-4 py-2 text-right font-semibold text-muted-foreground hidden sm:table-cell'>
                Scope 2 (tCO2e)
              </th>
              <th className='w-1/5 px-4 py-2 text-right font-semibold text-muted-foreground hidden sm:table-cell'>
                Scope 3 (tCO2e incl. WTT*)
              </th>
            </tr>
          </thead>
          <tbody>
            {orgs?.map((org) =>
              customLabels?.map((custCat, index) => {
                const categoryData =
                  emissionsByCustomCategory && emissionsByCustomCategory[org] && emissionsByCustomCategory[org][custCat];
                return (
                  <EmissionsDisaggregatedByCustomCategoryRow
                    key={`${org}-${index}`}
                    customCategory={custCat}
                    customCategoryData={categoryData}
                    organisation={org}
                  />
                );
              }),
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { emissionsByCustomCategory, customCategories } = state.consumption;
  const currentOrganisation = state.currentOrganisation;
  const reportYear = state.report?.details?.year;
  const childOrgs = state.report?.includedOrgs || [];
  const orgs = [currentOrganisation, ...childOrgs];

  const customLabels = customCategories && customCategories.filter((custCat) => custCat !== null);

  return {
    emissionsByCustomCategory: emissionsByCustomCategory && reportYear && emissionsByCustomCategory[reportYear],
    customLabels,
    orgs,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsDisaggregatedByCustomCategory);
